export default {

  getNumber: function(min,max){
    var num = Math.floor(Math.random() * ((max + 1) - min)) + min;
    return num > max ? max : num;
  },

  getShuffledArray: function(min,max){
    var baseArray = [];
    for (var i = min;i < max;i++){
      baseArray.push(i);
    }
    return this.shuffleArray(baseArray);
  },

  shuffleArray: function(baseArray){
    for (var i = 0;i < baseArray.length;i++){
      var j = this.getNumber(0,baseArray.length - 1);
      var temp = baseArray[i];
      baseArray[i] = baseArray[j];
      baseArray[j] = temp;
    }
    return baseArray;
  }

};